import react from 'react';
import { FaFlask, FaTint } from 'react-icons/fa';
import { FaBottleWater } from 'react-icons/fa6';
import { useInViewAnimation } from './useInViewAnimation';
function Boxes() {
    const [ref1, isVisible1] = useInViewAnimation(0.2);
    const [ref2, isVisible2] = useInViewAnimation(0.2);
    const [ref3, isVisible3] = useInViewAnimation(0.2);

    return (
        <div className='flex flex-col md:flex-row justify-evenly items-center py-10'
            style={{
                background: "linear-gradient(135deg, #F0FFFF 0%, #E0F7FF 35%, #B3E9FF 70%, #7FD4FF 100%)", 
                margin: '0px',
            }}
        >
            <div
                ref={ref1}
                className={`w-[200px] h-[200px] bg-[var(--header)] rounded-full border-[1px]  mb-5 md:mb-0 flex flex-col items-center justify-center transition-all duration-700 ease-out transform shadow-xl rounded-2xl ${isVisible1 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: '0s' }}
            >
                <FaTint className='text-[#c76982] bg-[#ffe8ef] rounded-full w-[100px] h-[100px] text-lg'/>
                <h3 className='mt-2 font-extrabold text-sm text-center'>مياه معالجة بالأوزون</h3>
            </div>

            <div
                ref={ref2}
                className={`w-[200px] h-[200px] bg-[var(--header)] rounded-full border-[1px]  mb-5 md:mb-0 flex flex-col items-center justify-center transition-all duration-700 ease-out transform shadow-xl rounded-2xl ${isVisible2 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: '0.5s' }}
            >
                <FaFlask className='text-[#c76982] bg-[#ffe8ef] rounded-full w-[100px] h-[100px]'/>
                <h3 className='mt-2 font-extrabold text-center text-sm'> نسبة صوديوم منخفضة </h3>
            </div>

            <div
                ref={ref3}
                className={`w-[200px] h-[200px] bg-[var(--header)] rounded-full border-[1px]  mb-5 md:mb-0 flex flex-col items-center justify-center transition-all duration-700 ease-out transform shadow-xl rounded-2xl ${isVisible3 ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: '0.9s' }}
            >
                {/*<FaRecycle className='text-[#c76982] bg-[#ffe8ef] rounded-full w-[100px] h-[100px]'/>*/}
                <FaBottleWater className='text-[#c76982] bg-[#ffe8ef] rounded-full w-[100px] h-[100px]' /> 
                <h3 className='mt-2 text-sm font-extrabold text-center'>عبوات ذات استخدام واحد</h3>
            </div>
        </div>
    )
}

export default Boxes;